module.exports = __webpack_public_path__ + "static/media/regimen-age.4a7cf83b.svg";